import React from "react";
import { createRouter } from "@tanstack/react-router";
import type { RouteIds } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { DefaultPendingComponent } from "shared-ts-router";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPendingComponent: () => <DefaultPendingComponent />,
  scrollRestoration: true,
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType["routeTree"]>;
